


















































































































































































































import { DialogForm } from '@/components/bwaff';
import {Component, Prop} from 'vue-property-decorator';
import Form, {Send} from '@/components/form-base';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import IntegrationsApi from  '@/services/rest/bemob/integrations';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import IntegrationMixin from '@/views/settings/integrations/custom-integrations/mixins/integration-mixin';

import { mixins } from 'vue-class-component';
import Vue from 'vue';
import CurrencyMixin from '@/components/helpers/currency-mixin';


interface mainForm  {
  name:string,
  accessToken:string,
  type:string,
  id?:string,
  clientId?:string,
  meta:{
    facebookDefaultEventType:string,
    facebookCustomEventTypes: any[],
    currency: string,
    eventSourceUrl:string
    facebookParamEmailValue:string,
    facebookParamPhoneValue:string,
    facebookParamGenderValue:string,
    facebookParamFirstNameValue:string,
    facebookParamLastNameValue:string,
    facebookParamZipCodeValue:string,
  }
}

@Component({
  components: {
    DialogForm,
    HeaderButtons,
    ErrorAggregator
  }
})
export default class CreateIntegrationDialogFacebook extends mixins<Form,IntegrationMixin,CurrencyMixin>(Form,IntegrationMixin,CurrencyMixin) {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  loading: boolean = false;
  isEdit: boolean = false;
  tokenEditMode: boolean = false;
  savedToken: string = '';
  errorsRaw: any = {};

  integration: Integration = {
    name: '',
    type: '',
    img: {
      src:''
    },
    guideLink: '',
    help: ''
  };
  integrationsApi: IntegrationsApi = new IntegrationsApi();
  form: mainForm = {
    name:'',
    accessToken:'',
    type:'',
    id:'',
    meta:{
      facebookDefaultEventType:'',
      facebookCustomEventTypes:[],
      currency: this.$store.state.user.currencyId,
      eventSourceUrl:'',
      facebookParamEmailValue:'',
      facebookParamPhoneValue:'',
      facebookParamGenderValue:'',
      facebookParamFirstNameValue:'',
      facebookParamLastNameValue:'',
      facebookParamZipCodeValue:'',
    }
  };

  customEvents(index:number) {
    const customEvents = Object.values(this.$store.state.table.customEvents) as customEvent[]
    return customEvents.filter((item:customEvent)=>{
      // take selected
      return this.form.meta.facebookCustomEventTypes[index]?.customEventId===item.id || (
        // don't take archived
        item.status !== 'archived' &&
        item.sendPostback &&
        // don't take chosen in other selects
        !this.form.meta.facebookCustomEventTypes.find((item2=>item2.customEventId===item.id))
      )
    }).map((item)=>({
      ...item,
      text: item.status === 'archived' ? `${item.name} (${this.t('Archived').toLowerCase()})` : item.name
    })) || []
  }

  addFacebookEventType() {
    const newValue = [...this.form.meta.facebookCustomEventTypes]
    newValue.push({
      customEventId:'',
      facebookEventType:'',
    })
    Vue.set(this.form.meta, 'facebookCustomEventTypes', newValue);
  }

  deleteFacebookEventType(index) {
    this.form.meta.facebookCustomEventTypes.splice(index, 1)
  }

  getEventTypesError({index,field}){
    const err = this.errorsRaw?.meta?.facebookCustomEventTypes?.[index]?.[field];
    if(err){
      return [this.t(err,[this.t(field)])];
    }
  }
  
  errors: any[] = [];
  errorsControlActive: boolean = false;

  close() {
    this.$emit('close');
  }

  @Send(true)
  save(){
    const method = this.isEdit ? 'put' : 'post'

    this.loading = true;
    return this.integrationsApi[method](this.dataToSend).then(()=>{
      this.close();
      this.bus.emit('toast-success', this.t('Integration has been saved'));
    }).catch((error:any) => {
      return Promise.reject(error);
    }).finally(()=>{
      this.loading = false;
    });
  }

  get dataToSend(){
    const { name, accessToken, id, type, clientId = '',meta } = this.form;
    return {
      ...(this.isEdit && { id }),
      ...((this.isEdit && this.tokenEditMode || !this.isEdit) && { accessToken }),
      name,
      clientId, 
      type,
      meta
    }
  }


  mounted() {
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);
      
      // move errors from field 'meta'
      const errorsRaw = {
        ...e.data.errors,
        ...(e.data.errors?.meta || {}),
      }
      
      delete errorsRaw.meta
      
      this.errors = this.translateErrors(this.parseErrors(errorsRaw), e.data.message);
      
      this.errorsControlActive = true;
      this.errorsRaw = e.data.errors;
    });

    const { type } = this.data;
    this.integration = this.integrationsData[type]

    this.form = {
      ...this.form,
      ...this.data,
      meta:{
        ...this.form.meta,
        ...this.data.meta
      }
    };


    this.tokenEditMode = false;
    if(this.data.id){
      this.isEdit = true;
      this.savedToken = this.data.accessToken;
    }

    this.show = true;
  }

  handleEditTokenMode() {
    if(this.tokenEditMode){
      this.form.accessToken=this.savedToken
    }else{
      this.form.accessToken=''
    }
    this.tokenEditMode=!this.tokenEditMode
  }
}
